// require('./src/components/layout.scss')
// require('./src/styles/index.scss')
// require('./src/styles/about.scss')
// require('./src/styles/art.scss')
require('bootstrap/dist/css/bootstrap.css');


